export default "__VITE_ASSET__bf5d41a5__"